import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { useSqfImport } from '../context/SqfImportContext';
import { useLanguage, t } from '../context/LanguageContext';

const STATUS_COLOR = {
  uploading:  '#0d6efd',
  processing: '#fd7e14',
  done:       '#198754',
  error:      '#dc3545',
};

const STATUS_ICON = {
  uploading:  null,   // spinner
  processing: null,   // spinner
  done:       '✅',
  error:      '❌',
};

export default function SqfImportToast() {
  const { status, message, dismiss } = useSqfImport();
  const { lang } = useLanguage();

  if (!status) return null;

  const spinning = status === 'uploading' || status === 'processing';
  const color    = STATUS_COLOR[status] || '#6c757d';
  const icon     = STATUS_ICON[status];

  return ReactDOM.createPortal(
    <div
      className="app-no-print"
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 9999,
        minWidth: 300,
        maxWidth: 380,
        background: '#fff',
        border: `2px solid ${color}`,
        borderRadius: 10,
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        padding: '14px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {/* Header row */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {spinning
          ? <span className="spinner-border spinner-border-sm" style={{ color, flexShrink: 0 }} />
          : <span style={{ fontSize: 18, lineHeight: 1 }}>{icon}</span>
        }
        <span style={{ fontWeight: 600, fontSize: 13, color, flexGrow: 1 }}>
          {status === 'uploading'  && t('Uploading file…',         'Subiendo archivo…',     lang)}
          {status === 'processing' && t('Processing with AI…',     'Procesando con IA…',    lang)}
          {status === 'done'       && t('Import complete',         'Importación completa',  lang)}
          {status === 'error'      && t('Import failed',           'Error en importación',  lang)}
        </span>
        {(status === 'done' || status === 'error') && (
          <button
            onClick={dismiss}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: 18, lineHeight: 1, padding: 0 }}
          >
            ×
          </button>
        )}
      </div>

      {/* Message */}
      <div style={{ fontSize: 12, color: '#555', paddingLeft: 26 }}>
        {message}
      </div>

      {/* Progress bar for processing */}
      {spinning && (
        <div style={{ paddingLeft: 26 }}>
          <div style={{ height: 4, background: '#e9ecef', borderRadius: 2, overflow: 'hidden' }}>
            <div
              style={{
                height: '100%',
                width: status === 'uploading' ? '30%' : '70%',
                background: color,
                borderRadius: 2,
                transition: 'width 0.5s ease',
              }}
            />
          </div>
        </div>
      )}

      {/* Done: link to hub */}
      {status === 'done' && (
        <div style={{ paddingLeft: 26 }}>
          <Link
            to="/sqf/hub"
            onClick={dismiss}
            style={{ fontSize: 12, color: STATUS_COLOR.done, fontWeight: 600, textDecoration: 'none' }}
          >
            {t('Go to Audit Hub →', 'Ir al hub de auditoría →', lang)}
          </Link>
        </div>
      )}
    </div>,
    document.body
  );
}
